import { InjectionToken, makeEnvironmentProviders } from '@node_modules/@angular/core';
import { HttpCacheConfig } from '@app/core/http/models/http-cache-config.model';
import { EnvironmentProviders, Provider } from '@angular/core';
import { HttpCacheService } from '@app/core/http/services/http-cache.service';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { httpCacheInterceptor } from '@app/core/http/interceptors/http-cache.interceptor';

const _defaultConfig: HttpCacheConfig = {
    millisTimeToLive: 7_200_000,
    endpoints: [],
};

export const HTTP_CACHE_CONFIG = new InjectionToken<HttpCacheConfig>('httpCacheConfig');

export const provideHttpCache = (config?: Partial<HttpCacheConfig>): EnvironmentProviders => {
    const providers: (Provider | EnvironmentProviders)[] = [
        {
            provide: HTTP_CACHE_CONFIG,
            useFactory: () => ({ ..._defaultConfig, ...config }),
        },
        HttpCacheService,
        provideHttpClient(withInterceptors([httpCacheInterceptor])),
    ];

    return makeEnvironmentProviders([...providers]);
};
